/**
 * Textarea Atom
 *
 * A multi-line text input element for longer text content.
 */

import * as React from 'react';

import { cn } from '@/lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  description?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, description, ...props }, ref) => {
    const generatedId = React.useId();
    const textareaId = props.id || generatedId;
    return (
      <div className='flex w-full flex-col'>
        {label && (
          <label htmlFor={textareaId} className='visible mb-2 block text-sm opacity-100'>
            {label}
          </label>
        )}
        <textarea
          id={textareaId}
          className={cn(
            'peer flex w-full justify-start border border-gray2 bg-transparent p-3 font-normal ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 invalid:border-2 invalid:border-primary-600 focus:border-b-2 focus-visible:border-slate-700 focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-slate-200 disabled:opacity-50 dark:border-slate-800 dark:bg-slate-950',
            className
          )}
          ref={ref}
          {...props}
        />
        {description && <p className='text-xs text-slate-500 peer-invalid:text-primary-600'>{description}</p>}
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
